import { configurationIdentityServer } from './global/config.tsx'
import { OidcProvider } from '@axa-fr/react-oidc'
import { BrowserRouter } from 'react-router-dom'
import { enableRipple, loadCldr, setCulture, setCurrencyCode } from '@syncfusion/ej2-base'
import store from './redux/store'
import { Provider } from 'react-redux'

import './styles/general/app.scss'
import LandingPage from './global/LandingPage.tsx'
import { useMemo } from 'react'

import * as n1 from '../node_modules/cldr-data/main/de/currencies.json'
import * as n2 from '../node_modules/cldr-data/main/de/timeZoneNames.json'
import * as n3 from '../node_modules/cldr-data/main/de/numbers.json'
import * as n4 from '../node_modules/cldr-data/main/de/ca-gregorian.json'
import * as s from '../node_modules/cldr-data/supplemental/currencyData.json'
import * as s2 from '../node_modules/cldr-data/supplemental/numberingSystems.json'
import { loadLocalization } from './translations/sf-translations.tsx'

const Authenticating = () => <p>Anmeldung</p>

enableRipple(true)

setCurrencyCode('EUR')
loadCldr(n1, n2, n3, n4, s, s2)
setCulture('de')
loadLocalization()

function App() {
  const oidcConfig = useMemo(() => configurationIdentityServer, [])

  return (
    <>
      <OidcProvider configuration={oidcConfig} authenticatingComponent={Authenticating}>
        <BrowserRouter>
          <Provider store={store}>
            <LandingPage />
          </Provider>
        </BrowserRouter>
      </OidcProvider>
    </>
  )
}

export default App
